module.exports = __webpack_public_path__ + "static/media/CYFLogo.0d2d8a2f.png";